module.exports = "<div class=\"yt-player-container\" #ytPlayerContainer></div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/youtube-player/youtube-player.component.html
// module id = ../../../../../src/app/youtube-player/youtube-player.component.html
// module chunks = 4